import { useMemo } from "react";
import { useFigmaContextScope } from "../figma-context-scope";
import { extractFigmaTargets, figmaTargetKey } from "../figma-url";
import { FigmaContextCard } from "./figma-context-card";

/**
 * CR-126 (D7): one card per distinct Figma target linked from a message's
 * text, rendered after it. Nothing renders outside a FigmaContextScope.
 */
export function FigmaContextCards({ text }: { text: string }) {
  const scope = useFigmaContextScope();
  const targets = useMemo(() => extractFigmaTargets(text), [text]);
  if (!scope || targets.length === 0) {
    return null;
  }
  return (
    <div data-testid="figma-context-cards" className="flex flex-col">
      {targets.map((target) => (
        <FigmaContextCard key={figmaTargetKey(target)} target={target} scope={scope} />
      ))}
    </div>
  );
}
